import { render, staticRenderFns } from "./InquiryFormTicketQuantity.vue?vue&type=template&id=6f118cb8&"
import script from "./InquiryFormTicketQuantity.vue?vue&type=script&lang=js&"
export * from "./InquiryFormTicketQuantity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports